export default __webpack_public_path__ + "static/blurred-bg-852353123318f9417e1d092a21890c96.png";